import { LegalDocument } from '../model/LegalDocument';
import { LegalDocumentType } from '../model/LegalDocumentType';

import { LegalDocumentVersion } from './api/BaseLegalDocument';
import { ApprovedLegalDocument as ApprovedApiLegalDocument } from './api/GetApprovedDocumentApiResult';
import { LegalDocument as ToApproveApiLegalDocument } from './api/GetToApproveDocumentApiResult';

function mapDocument(
    documentType: LegalDocumentType,
    version: LegalDocumentVersion,
    currentLanguage: string,
): LegalDocument {
    const translation = version.translations.find((t) => t.languageCode === currentLanguage) ?? version.translations[0];
    const lastRevision = translation.revisions[translation.revisions.length - 1];

    return {
        documentType,
        language: translation.languageCode,
        url: lastRevision.fileServerUrl,
    };
}

export function fromToApproveApiResponse(document: ToApproveApiLegalDocument, currentLanguage: string): LegalDocument {
    return mapDocument(document.documentType, document.latestApplicableVersion, currentLanguage);
}

export function fromApprovedApiResponse(document: ApprovedApiLegalDocument, currentLanguage: string): LegalDocument {
    return mapDocument(document.documentType, document.approvedVersion, currentLanguage);
}
